export const DEFAULT_CLOSED_EVENT_MESSAGE =
  'If you think this is a mistake, please contact the agency that gave you the event link.'
